import React from 'react';
import { Clock, FileText, CalendarCheck, CheckCircle2, ShieldCheck } from 'lucide-react';
export const CompanyValueProps = () => {
  return <section className="mt-16 mb-16 bg-[#FEECCF] rounded-xl p-6 md:p-8" data-id="element-439">
      <h2 className="text-xl font-semibold text-[#111010] mb-6 text-center" data-id="element-440">
        Waarom kiezen voor BTB Bouwbedrijf?
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-441">
        <div className="flex" data-id="element-442">
          <div className="mr-4 mt-1" data-id="element-443">
            <FileText className="h-6 w-6 text-[#FCCA86]" data-id="element-444" />
          </div>
          <div data-id="element-445">
            <h3 className="font-medium text-[#111010] mb-1" data-id="element-446">
              Duidelijke, transparante offertes
            </h3>
            <p className="text-sm text-gray-700" data-id="element-447">
              Geen verborgen kosten of 'kleine lettertjes' – wij hanteren een
              scherpe all-in prijs.
            </p>
          </div>
        </div>
        <div className="flex" data-id="element-448">
          <div className="mr-4 mt-1" data-id="element-449">
            <Clock className="h-6 w-6 text-[#FCCA86]" data-id="element-450" />
          </div>
          <div data-id="element-451">
            <h3 className="font-medium text-[#111010] mb-1" data-id="element-452">
              Snel en betrouwbaar
            </h3>
            <p className="text-sm text-gray-700" data-id="element-453">
              U ontvangt een complete offerte binnen 48 uur en wij kunnen
              meestal starten binnen 2-3 weken.
            </p>
          </div>
        </div>
        <div className="flex" data-id="element-454">
          <div className="mr-4 mt-1" data-id="element-455">
            <CalendarCheck className="h-6 w-6 text-[#FCCA86]" data-id="element-456" />
          </div>
          <div data-id="element-457">
            <h3 className="font-medium text-[#111010] mb-1" data-id="element-458">
              Flexibele prijsindicatie
            </h3>
            <p className="text-sm text-gray-700" data-id="element-459">
              Heeft u een woning op het oog? Wij bieden vrijblijvende
              prijsindicaties om u te helpen bij uw aankoop.
            </p>
          </div>
        </div>
        <div className="flex" data-id="element-460">
          <div className="mr-4 mt-1" data-id="element-461">
            <ShieldCheck className="h-6 w-6 text-[#FCCA86]" data-id="element-462" />
          </div>
          <div data-id="element-463">
            <h3 className="font-medium text-[#111010] mb-1" data-id="element-464">
              Kwaliteit en vakmanschap
            </h3>
            <p className="text-sm text-gray-700" data-id="element-465">
              Ons ervaren team zorgt voor vakwerk en kwaliteit, of het nu gaat
              om een badkamerverbouwing of complete renovatie.
            </p>
          </div>
        </div>
      </div>
    </section>;
};